import { render, staticRenderFns } from "./UserDataUpdateForm.vue?vue&type=template&id=1c0d3bc4&scoped=true&"
import script from "./UserDataUpdateForm.vue?vue&type=script&lang=js&"
export * from "./UserDataUpdateForm.vue?vue&type=script&lang=js&"
import style0 from "./UserDataUpdateForm.vue?vue&type=style&index=0&id=1c0d3bc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0d3bc4",
  null
  
)

export default component.exports